import { FC } from 'react';
import { AnimatedShape, Box } from '@altermaind/web/ui';

type Props = {
  hasHeaderRow1?: boolean;
  hasHeaderRow2?: boolean;
  rows?: number;
};

export const SkeletonTable: FC<Props> = ({
  hasHeaderRow1 = false,
  hasHeaderRow2 = true,
  rows = 11,
}) => {
  return (
    <>
      {hasHeaderRow1 && (
        <Box
          p='none'
          shadow='soft'
          borderRadius='xs'
          display='flex'
          flexDirection='row'
          gridGap={30}
          width='100%'
          flex={4}
          mb='xs'
        >
          <Box flex={1.5} />
          <Box flex={1} />
          <Box flex={1} flexDirection='column' />
          <Box flex={0.5} justifyContent='flex-end'>
            <AnimatedShape variant='round' width='100%' height={50} />
          </Box>
        </Box>
      )}
      {hasHeaderRow2 && (
        <Box
          p='none'
          shadow='soft'
          borderRadius='xs'
          display='flex'
          flexDirection='row'
          gridGap={30}
          width='100%'
          flex={4}
        >
          <Box flex={1.5} />
          <Box flex={1} />
          <Box flex={0.5} />
          <Box flex={1.5} justifyContent='flex-end'>
            <AnimatedShape variant='round' width='100%' height={30} />
          </Box>
        </Box>
      )}
      {Array.from({ length: rows }).map((_element, i: number) => (
        <Box
          // eslint-disable-next-line react/no-array-index-key
          key={`row_${i}`}
          p='none'
          mt='xs'
          shadow='soft'
          borderRadius='xs'
          display='flex'
          flexDirection='row'
          width='100%'
          flex={4}
        >
          <Box flex={1}>
            <AnimatedShape variant='round' width='100%' height={47} />
          </Box>
        </Box>
      ))}
      <Box
        p='none'
        mt='xs'
        shadow='soft'
        borderRadius='xs'
        display='flex'
        flexDirection='row'
        gridGap={30}
        width='100%'
        flex={4}
      >
        <Box flex={1.5} />
        <Box flex={1} />
        <Box flex={1} justifyContent='flex-end'>
          <AnimatedShape variant='round' width='100%' height={30} />
        </Box>
      </Box>
    </>
  );
};
